import {AfterViewInit, Component, OnDestroy} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {Router} from "@angular/router";
import {Location} from '@angular/common';

declare let $: any;


@Component({
	selector: "tig-blank",
	templateUrl: "blankLayout.template.html"
})
export class BlankLayoutComponent implements AfterViewInit, OnDestroy
{


	/**
	 *
	 * Function > constructor
	 * @param {Router} OBJ_router
	 * @param {object} OBJ_translate_service
	 * @param {Location} OBJ_location
	 */
	constructor(public OBJ_router: Router, public OBJ_translate_service: TranslateService, private OBJ_location: Location) {} // end function constructor


	/**
	 * Function > ngAfterViewInit
     * @return {void}
	 */
	ngAfterViewInit(): void
	{
		$("body").addClass("gray-bg");
		let $OBJ_element = $(".btn-top");
		
		$(window).scroll(function()
		{
			if ($(this).scrollTop() > 200) {
				if (!$OBJ_element.is(':visible')) {
					$OBJ_element.stop(true, true).fadeIn();
				}
			} else {
				if (!$OBJ_element.is(':animated')) {
					$OBJ_element.stop(true, true).fadeOut();
				}
			}
		});

	} // end function ngAfterViewInit


	/**
	 * Function > ngOnDestroy
     * @return {void}
	 */
	ngOnDestroy(): void
	{
		$("body").removeClass("gray-bg");
	} // end function ngOnDestroy


	/**
	 * Function > toggleDropdown
	 */
	toggleDropdown(): void
	{
		$(".dropdown").toggleClass("open");
	} // end function toggleDropdown
	
	
	/**
	 * Function > goBack
	 * @desc Go navigation back
	 */
	goBack(): void {
		this.OBJ_location.back();
	} // end function goBack
	
	/**
	 * Function > goTop
	 * @desc Go to top
	 */
	goTop(): void {
		window.scrollTo({left: 0, top: 0, behavior: 'smooth'});
	} // end function goTop

} // end class BlankLayoutComponent